import { render, staticRenderFns } from "./ProducingPromoBanner.vue?vue&type=template&id=8783bb54&scoped=true&"
import script from "./ProducingPromoBanner.vue?vue&type=script&lang=js&"
export * from "./ProducingPromoBanner.vue?vue&type=script&lang=js&"
import style0 from "./ProducingPromoBanner.vue?vue&type=style&index=0&id=8783bb54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8783bb54",
  null
  
)

export default component.exports